import { render, staticRenderFns } from "./TradeDeskAnalyticsTracker.vue?vue&type=template&id=22b2dc9c&"
import script from "./TradeDeskAnalyticsTracker.vue?vue&type=script&lang=js&"
export * from "./TradeDeskAnalyticsTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports